// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2yGVJ","row":"ProcedureTreatmentSummary_row__1QA2j"};